export default () => dispatch => {
    dispatch({
        type: 'HIDE_SNACKBAR_MESSAGE',
        payload: ""
    })
}